export default {
  props: {
    rows: {
      type: Number,
      default: 100,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    hasStatistical: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      lastPageNumber: 0,
    };
  },
  watch: {
    currentPage(value) {
      this.$emit("update:currentPage", value);
    },
  },
};
